import { Box, Grid, Tooltip } from '@lifechurch/react-ion';
import React, { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

const HeaderItem: React.FC<PropsWithChildren> = ({ children }) => (
  <Box display='flex' fontWeight={2} lineHeight={1.25}>
    {children}
  </Box>
);

const TableHeader: FC = () => {
  const { t } = useTranslation(['analytics_services', 'common']);
  return (
    <Grid
      fontSize={2}
      gridColumnGap='1rem'
      gridTemplateColumns='61px 1fr 120px 102px 82px 17px'
      marginBlockEnd={3}
      marginBlockStart={5}
    >
      <HeaderItem>{t('common:moment')}</HeaderItem>
      <HeaderItem>{t('common:content')}</HeaderItem>
      <HeaderItem>{t('post_time')}</HeaderItem>
      <HeaderItem>
        {t('impressions')}
        <Box display='flex' marginInlineStart={1}>
          <Tooltip content={t('impressions_tooltip')} placement='top' />
        </Box>
      </HeaderItem>
      <HeaderItem>{t('interactions')}</HeaderItem>
    </Grid>
  );
};

export { TableHeader };
